import { useCallback } from "react";
import { PendingNewPage, GeneratingPage, usePage } from "../context/PageContext";
import { Page, PageTab } from "../types";
import { Widget } from "@/modules/widgets";
import { pageEndpoints } from "../api/endpoints";

export const usePageActions = () => {
    const { dispatch, state } = usePage();
    const updatePage = useCallback(
        (page: Page) => {
            dispatch({ type: "UPDATE_PAGE", payload: page });
        },
        [dispatch]
    );
    const setPages = useCallback(
        (pages: Page[]) => {
            dispatch({ type: "SET_PAGES", payload: pages });
        },
        [dispatch]
    );
    const setCurrentPage = useCallback(
        (page: Page | null) => {
            dispatch({ type: "SET_CURRENT_PAGE", payload: page });
        },
        [dispatch]
    );
    const setLoading = useCallback(
        (loading: boolean) => {
            dispatch({ type: "SET_LOADING", payload: loading });
        },
        [dispatch]
    );

    const setError = useCallback(
        (error: string | null) => {
            dispatch({ type: "SET_ERROR", payload: error });
        },
        [dispatch]
    );
    const deletePageWidget = useCallback(
        (pageId: number, widgetId: number) => {
            dispatch({ type: "DELETE_PAGE_WIDGET", payload: { pageId, widgetId } });
        },
        [dispatch]
    );
    const updatePageWidget = useCallback(
        (pageId: number, widget: Widget) => {
            dispatch({ type: "UPDATE_PAGE_WIDGET", payload: { pageId, widget } });
        },
        [dispatch]
    );

    const setCurrentPageWidgetsData = useCallback(
        (widgetWithData: Widget & { data: any }) => {
            dispatch({ type: "SET_CURRENT_PAGE_WIDGETS_DATA", payload: widgetWithData });
        },
        [dispatch]
    );

    const deletePage = useCallback(
        (pageId: number) => {
            dispatch({ type: "DELETE_PAGE", payload: pageId });
        },
        [dispatch]
    );

    const setCurrentTab = useCallback(
        (tab: PageTab | null) => {
            dispatch({ type: "SET_CURRENT_TAB", payload: tab });
        },
        [dispatch]
    );

    const setPendingNewPage = useCallback(
        (pending: PendingNewPage | null) => {
            dispatch({ type: "SET_PENDING_NEW_PAGE", payload: pending });
        },
        [dispatch]
    );

    const setGeneratingPage = useCallback(
        (generating: GeneratingPage | null) => {
            dispatch({ type: "SET_GENERATING_PAGE", payload: generating });
        },
        [dispatch]
    );

    return {
        updatePage,
        setPages,
        setCurrentPage,
        setLoading,
        setError,
        deletePageWidget,
        updatePageWidget,
        setCurrentPageWidgetsData,
        deletePage,
        setCurrentTab,
        setPendingNewPage,
        setGeneratingPage,
    };
};
